import { SANDBOX } from "../utils/config"

export async function verifyTurnstileToken(token: string | null, onVerified?: () => void) {
  if (!token) {
    // Turnstile not loaded (ad blocker, script failure) — allow through
    console.warn("[Turnstile] No token available, allowing request")
    return
  }

  try {
    const response = await fetch("/api/verify-turnstile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })

    if (!response.ok && !SANDBOX) {
      const data = (await response.json()) as { error?: string }
      if (data.error === "Bot detected") {
        throw new Error("Bot detected")
      }
    }

    // Token was consumed by Cloudflare — reset widget to generate a fresh one
    onVerified?.()
  } catch (error) {
    if (error instanceof Error && error.message === "Bot detected") {
      throw error
    }
    // Verification service unavailable — allow through
    console.warn("[Turnstile] Verification service unavailable, allowing request")
  }
}
